import React, { useEffect } from 'react';
import * as Styles from './ChooseSiteOption.styles';
import WordpressAIImageDesktopBR from '@/media/onboarding/wordpress-ai-option-br.png';
import WordpressAIImageDesktopES from '@/media/onboarding/wordpress-ai-option-es.png';
import {
  Button,
  IconWordpress,
  IconPicture,
  IconCode,
  IconStarsOutline,
  IconCheck,
  IconArrow,
} from 'gatorcomponents';
import { BlockOptions } from './BlockOptions';
import { isBRServer } from '@/utils/Validators/validation';
import { useResize } from '@/hooks/useResize';

const ChooseSiteOption = ({
  locales,
  buttonsProps,
  setCurrentFlow,
  goBack,
}) => {
  useEffect(() => {
    setCurrentFlow('');
  });

  const wordpressAIOption = {
    title: locales.wordpressAI.title,
    subtitle: locales.wordpressAI.subtitle,
    tag: locales.wordpressAI.tag,
    description: locales.wordpressAI.description,
    bulletPoints: locales.wordpressAI.bulletPoints,
    buttonLabel: locales.wordpressAI.buttonLabel,
    testId: 'wordpress-ai-block-button',
    buttonClick: () => buttonsProps.wordpressAI.onClick(),
  };

  const wordpressOption = {
    icon: <IconWordpress
      color="highDark"
      size="md"
      testId="wordpress-icon"
    />,
    title: locales.wordpress.title,
    subtitle: locales.wordpress.subtitle,
    description: locales.wordpress.description,
    buttonLabel: locales.wordpress.buttonLabel,
    buttonClick: () => buttonsProps.wordpress.onClick(),
    buttonTestId: 'wordpress-normal-block-button',
  };

  const siteBuilderOption = {
    icon: <IconPicture
      color="highDark"
      size="md"
      testId="sitebuilder-icon"
    />,
    title: locales.siteBuilder.title,
    subtitle: locales.siteBuilder.subtitle,
    description: locales.siteBuilder.description,
    buttonLabel: locales.siteBuilder.buttonLabel,
    buttonClick: () => buttonsProps.siteBuilder.onClick(),
    buttonTestId: 'sitebuilder-block-button',
  };

  const otherToolsOption = {
    icon: <IconCode
      color="highDark"
      size="md"
      testId="othertools-icon"
    />,
    title: locales.otherTools.title,
    subtitle: locales.otherTools.subtitle,
    description: locales.otherTools.description,
    buttonLabel: locales.otherTools.buttonLabel,
    buttonClick: () => buttonsProps.otherTools.onClick(),
    buttonTestId: 'othertools-block-button',
  };

  const windowRect = useResize();
  const { width } = windowRect;
  const isDesktop = width > 1280;

  return (
    <Styles.Wrapper data-testid="choose-site-option-step">
      <Styles.Greeting>
        {locales.greeting}
      </Styles.Greeting>

      <Styles.WordpressAIWrapper>
        <Styles.WordpressAIContainer>
          <Styles.WordpressAIAbout>
            <Styles.WordpressAIAboutContent>

              <Styles.WordpressAIAboutHeader>
                <Styles.WordpressAITag>
                  {wordpressAIOption.tag}
                </Styles.WordpressAITag>
                <Styles.WordpressAITitle>{wordpressAIOption.title}</Styles.WordpressAITitle>
              </Styles.WordpressAIAboutHeader>

              <Styles.WordpressAIDescription>{wordpressAIOption.description}</Styles.WordpressAIDescription>
              <Styles.BulletPointsList>
                {wordpressAIOption.bulletPoints.map(item => (
                  <Styles.BulletPointsItem>
                    <IconCheck color="activePure" />
                    { item }
                  </Styles.BulletPointsItem>
                ))}
              </Styles.BulletPointsList>
              <Styles.WordpressAIButton>
                <Button
                  iconLeft={null}
                  iconRight={<IconStarsOutline size="md" color="highPure" />}
                  label={wordpressAIOption.buttonLabel}
                  title={wordpressAIOption.buttonLabel}
                  size="large"
                  testId={wordpressAIOption.testId}
                  variant="primary"
                  width="fit-content"
                  onClick={wordpressAIOption.buttonClick}
                />
              </Styles.WordpressAIButton>
            </Styles.WordpressAIAboutContent>
          </Styles.WordpressAIAbout>

          {isDesktop && <Styles.WordpressAIImage src={isBRServer ? WordpressAIImageDesktopBR : WordpressAIImageDesktopES} />}
        </Styles.WordpressAIContainer>
      </Styles.WordpressAIWrapper>

      <Styles.OthersOptionsWrapper>
        <BlockOptions {...siteBuilderOption} />
        <BlockOptions {...wordpressOption} />
        <BlockOptions {...otherToolsOption} />
      </Styles.OthersOptionsWrapper>

      {goBack && (
      <Styles.BackWrapper>
        <Button
          iconLeft={<IconArrow direction="left" size="md" color="primaryBlue" />}
          label="Voltar"
          title="Voltar"
          size="large"
          testId="backButton"
          variant="tertiary"
          width="fit-content"
          onClick={goBack}
        />
      </Styles.BackWrapper>
      )}
    </Styles.Wrapper>
  );
};

export default ChooseSiteOption;
